export default __webpack_public_path__ + "static/media/5.5441e780.jpg";